// ─────────────────────────────────────────────────────────────
// FIREBASE CONFIG
// Step 1: Go to https://console.firebase.google.com
// Step 2: Create project → name it "omcares"
// Step 3: Add Web App → copy the config object below
// Step 4: Enable Firestore Database (test mode)
// Step 5: Enable Storage (test mode)
// Step 6: Enable Authentication → Email/Password
// Step 7: Replace all YOUR_* values below with real values
// ─────────────────────────────────────────────────────────────
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDKkT4RCwgHXB3Vp-N10muDOwzYItgDj0Y",
  authDomain: "omcares.firebaseapp.com",
  projectId: "omcares",
  storageBucket: "omcares.firebasestorage.app",
  messagingSenderId: "987111569762",
  appId: "1:987111569762:web:98acf36f9302b4a105543b"
};

const app    = initializeApp(firebaseConfig);
export const db      = getFirestore(app);
export const storage = getStorage(app);
export const auth    = getAuth(app);
export default app;